import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Globe } from "lucide-react";

const Navbar = () => {
  const location = useLocation();

  return (
    <nav className="navbar">
      <h1 className="logo">
        W<span className="globe"><Globe size={20} /></span>rldOfBia
      </h1>
      <ul className="nav-links">
        <li><Link to="/" className={location.pathname === "/" ? "active" : ""}>Home</Link></li>
        <li><Link to="/portfolio" className={location.pathname === "/portfolio" ? "active" : ""}>Portfolio</Link></li>
        <li><Link to="/profile" className={location.pathname === "/profile" ? "active" : ""}>Profile</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
